import React from "react";

type ProfitProps = React.SVGProps<SVGSVGElement>;

export const Profit = (props: ProfitProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9923 4.89648H9.49232V5.89648H12.2853L8.49232 9.68948L5.49232 6.68948L2.00732 10.1745L2.71432 10.8815L5.49232 8.10348L8.49232 11.1035L12.9923 6.60348V9.39648H13.9923V5.89648C13.9923 5.34498 13.5438 4.89648 12.9923 4.89648Z"
      fill="currentColor"
    />
  </svg>
);
